import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../../utils/axios';
import { QueryKeys } from '../../querys/querys.enum';
import { message } from 'antd';

export interface CreateInternalSubscriptionDto {
  subUserId: string;
  package: string;
  nextBillingDate: number; // Unix timestamp in seconds
}

export interface CreateInternalSubscriptionResponse {
  message: string;
  subscriptionId: string;
  subscription?: any;
}

const useCreateInternalSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateInternalSubscriptionResponse, Error, CreateInternalSubscriptionDto>({
    mutationFn: async (data: CreateInternalSubscriptionDto) => {
      const response = await axiosInstance.post('/subscriptions/create-internal-subscription', data);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate and refetch subscriptions list
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SUBSCRIPTIONS] });
      message.success(data.message || 'Subscription created successfully');
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Failed to create subscription';
      message.error(errorMessage);
      console.error('Error creating subscription:', error);
    },
  });
};

export default useCreateInternalSubscription;
